// Import and initialize polyfills FIRST, before any other code
// This ensures critical APIs (URLSearchParams, Promise) are available in older browsers
import { initializePolyfills } from './services/utilities/polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import ReduxToastr from 'react-redux-toastr';
import * as Sentry from "@sentry/react";

// Initialize polyfills after all imports
initializePolyfills();

Sentry.init({
    dsn: "https://28e329113ea6594e891e622b35eed16b@o4509275099693056.ingest.de.sentry.io/4509275101462608",
    sendDefaultPii: true,
    integrations: [
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false
        })
    ],
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
        <Provider store={store}>
            <div>
                <ReduxToastr
                    timeOut={5000}
                    newestOnTop={false}
                    preventDuplicates
                    position="bottom-center"
                    getState={(state) => state.toastr}
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                    progressBar
                    closeOnToastrClick />
            </div>
            <App />
        </Provider>
    </Sentry.ErrorBoundary>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
